import { plainToClassFromExist, instanceToInstance, } from 'class-transformer';
import { Model, } from './Model';
import { ModelFactory } from './ModelFactory';

export class MarshalModelFactory<T extends Model> extends ModelFactory<T> {
	constructor(protected exampleObject: any) {
		super(exampleObject);
	}

	override createNew(json: any): T {
		const subModel: T = plainToClassFromExist(this.exampleObject, json);
		const model: T = instanceToInstance(subModel);
		model.originalJson = json;
		return model;
	}

	override newCopy(record: T): T {
		const model: T = instanceToInstance(record);
		model.id = null;
		model.originalJson.id = null;
		model['_isNew'] = true;
		return model;
	}

	// clone keeps the id the same
	override clone(record: T): T {
		const model: T = instanceToInstance(record);
		return model;
	}

	override massage(records: T[]): T[] {
		return records;
	}
}
